import { styled } from "@mui/material";
import { loginLayoutName } from "../classes.js";
const Footer = styled("div", {
  name: loginLayoutName,
  slot: "Footer",
  overridesResolver: (_, styles) => styles.footer
})(({ theme }) => {
  const childSelector = "> *";
  const xsMediaSelector = theme.breakpoints.down("xs");
  return {
    gap: `${theme.spacing(0.5)} ${theme.spacing(3)}`,
    width: "100%",
    margin: theme.spacing(2),
    display: "flex",
    flexWrap: "wrap-reverse",
    textAlign: "center",
    alignItems: "center",
    whiteSpace: "nowrap",
    flexDirection: "row",
    justifyContent: "center",
    [childSelector]: {
      flex: "1 0 20%"
      // show 4 children per row. 20% accounts for margins
    },
    [xsMediaSelector]: {
      gap: `${theme.spacing(0.5)} ${theme.spacing(1)}`
    }
  };
});
export {
  Footer
};
//# sourceMappingURL=Footer.js.map
